<section class="" [ngClass]="{'content tab-section d-flex': !isAdmin}">
    <div class="" [ngClass]="{'content-block flex-grow-1': !isAdmin}">
        <div class="tab-content flex-grow-1 ">
            <!-- <canvas #signPadCanvas  (endStroke)="onEndStroke($event)" ></canvas> -->
            <div class="row ">
                <div class="col-lg-4 col-xxl-5 pe-4 pe-xxl-5">
                    <div>
                        <label for="">{{"MENUITEMS.CERTIFICATEMANAGEMENT.LOGO"|translate}}</label>


                        <div class="drop-box" *ngIf="(!certificateData?.cer_lo && !imagePath)">
                            <ngx-dropzone (change)="onSelect($event)" class="drop-item" accept="image/jpeg,image/jpg,image/png">
                              <ngx-dropzone-label >
                                  <div class="d-flex flex-column align-items-center">
                                      <div class="upload-img mr-2">
                                          <img src="assets/images/icons/upload.svg" class="img-fluid">
                                      </div>
                                      <div>
                                          <div>{{"COMMON.CTU" | translate}}</div>
                                          <div class="upload-text">{{"COMMON.DD" | translate}}</div>
                                      </div>
                                  </div>
                              <!-- <div class="note-txt pt-2">Note: File Size cannot be greater than 200MB.</div> -->
                              </ngx-dropzone-label>
                              <ngx-dropzone-preview *ngFor="let f of files"  (removed)="onRemove(f)" [removable]="true" >
                                  <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                              </ngx-dropzone-preview>
                            </ngx-dropzone>
                          </div>

                        <div class="c-box" *ngIf="(certificateData?.cer_lo || imagePath)" >
                            <div class="cer-b"   >  
                                <div class="cer-i" *ngIf="imagePath" [style.backgroundImage]="'url('+imagePath +')'"></div>    
                                <div class="cer-i" *ngIf="certificateData.cer_lo" [style.backgroundImage]="'url('+imageUrl+ certificateData.cer_lo +')'"></div>                         
                            </div>                           
                            <div class="e-ic d-flex align-items-center justify-content-center"  (click)="drop.showFileSelector()">
                                <i class="material-icons">mode_edit</i>
                            </div> 
                            <ngx-dropzone #drop (change)="onSelect($event)" class="d-none" [multiple]="false" accept="image/jpeg,image/jpg,image/png"></ngx-dropzone>
                        </div>
                    </div>
                    <div>
                        <mat-error *ngIf="isImageError">{{"VALIDATION.VALIDIMG" |translate}}</mat-error>                     
                        <div>
                            <div class="note-txt mt-2">{{"COMMON.NOTE"|translate}}:</div>                         
                            <div class="note-txt">{{"VALIDATION.IMGDIMENSION"|translate}}</div>
                        </div>
                    </div>
                    <div class="mt-3 mt-md-4">
                        <label for="">{{"MENUITEMS.CERTIFICATEMANAGEMENT.CMSG"|translate}}</label>
                        <textarea name="" class="form-control" [(ngModel)]="certificateData.c_msg"
                         placeholder="{{'COMMON.ENTER' | translate}} {{'MENUITEMS.CERTIFICATEMANAGEMENT.CMSG'|translate}}" id="" rows="2"></textarea>
                    </div>
                    <div class="mt-3 mt-md-4">
                        <label for="">{{"MENUITEMS.CERTIFICATEMANAGEMENT.SIGN"|translate}}</label>
                        <div class="signature-container" id="wrapper" #signbox>
                            <canvas #signPadCanvas class="sign-box"></canvas>
                        </div>
                        <div class="d-flex align-items-end justify-content-between align-items-center mt-3">
                            <p class=" mb-0 ">({{"MENUITEMS.CERTIFICATEMANAGEMENT.NEWSIGN"|translate}})</p>
                            <button type="button" class="btn btn-outline-primary d-flex  align-items-center"  (click)="clearSignPad()">
                                <img src="assets/images/certificates/clear.png" class="me-2">{{"MENUITEMS.CERTIFICATEMANAGEMENT.CLEAR"|translate}}</button>
                        </div>
                    </div>
                    <div class="mt-3 mt-md-4">                       
                        <img [src]="certificateData.sign" class="img-fluid" alt="">
                    </div>                    
                </div>
                <div class="col-lg-8  col-xxl-7  cert-cont d-flex flex-column ">
                    <div class="cert-head d-flex justify-content-between align-items-center ">
                        <div>{{"MENUITEMS.CERTIFICATEMANAGEMENT.TEMPLATE"|translate}}</div>
                        <div class="d-flex">
                            <div class="cursor-pointer" (click)="onViewChange()">
                                <img src="assets/images/certificates/landscape.png" *ngIf="!isLandscapeView" class="img-fluid" alt="">
                                <img src="assets/images/certificates/landscape_active.png" *ngIf="isLandscapeView" class="img-fluid" alt="">  
                            </div>
                            <div class="ms-2 cursor-pointer" (click)="onViewChange()">
                                <img src="assets/images/certificates/portrait_active.svg" *ngIf="!isLandscapeView" class="img-fluid" alt="">     
                                <img src="assets/images/certificates/portrait.png" *ngIf="isLandscapeView" class="img-fluid" alt="">                         
                            </div>
                        </div>
                    </div>
                    <div class="cer-main-box d-flex flex-wrap justify-content-center " >
                        <div class="cer-box" *ngFor="let item of filteredCertArr">
                            <img  [src]="imageUrl+item.certificate_image" class="img-fluid" (click)="onCertificateSelect(item)">
                            <div [ngClass]="item.selected ? 'selected-new animate'  : 'd-none'"></div>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end">
                <button type="button" class="btn auth-form-btn btn-outline-primary mt-3  me-3 align-items-center"> {{"BUTTON.CANCEL" |translate}}</button>
                <button mat-raised-button color="primary" class="auth-form-btn mt-3 no-sh-btn"  type="submit" (click)="submitCertificateData()">{{"BUTTON.SAVE"|translate}}</button>
            </div>
        </div>
    </div>
</section>
<!-- <app-loading-spinner></app-loading-spinner> -->